import React, { useEffect, useRef } from "react";
import makeStyles from '@mui/styles/makeStyles';
import swal from "sweetalert";
import {
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Card,
  CardContent,
  Button,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";
//import { Button } from "reactstrap";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "../../../actions/api";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";
import {
  AddCircle,
  DeleteOutline,
  Edit,
  TabletTwoTone,
} from "@mui/icons-material";
//import Tooltip from '@mui/material/Tooltip';
import Autocomplete from '@mui/material/Autocomplete';

//Import Preloader
import LoadingSpinnerOpaque from "services/LoadingSpinnerOpaque";
import { getLabFacilityList } from "../../../services/Common";
import encryptionService from "../../../services/encryptionService";
import {
  checkLogin,
  checkUserPermission,
  getUserActionPermission,
} from "../../../services/CheckUserAccess";

const LabQuarterClose = (props) => {
  console.log("props", props);
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const { t, i18n } = useTranslation();
  const menukey = "lab-quarter-close";
  const UserInfo = encryptionService.decryptUserInfo();
  const UserId = UserInfo == 0 ? "" : UserInfo[0].id;
  const UserName = UserInfo == 0 ? "" : UserInfo[0].name;

   // 1 = Admin Role Id
  const IsAdmin = UserInfo[0].role.filter((obj)=>{
    if(obj.id == 1)
    return obj;
  });

  //This is for user has VIEW/EDIT permission in this page start
  const permissionType = getUserActionPermission(menukey);
  // console.log('propsprops permissionType index: ', permissionType);
  //This is for user has VIEW/EDIT permission in this page end

  const FacilityId = localStorage.getItem("FacilityId");
  const YearList = JSON.parse(localStorage.getItem("YearList"));
  const QuarterList = JSON.parse(localStorage.getItem("QuarterList"));
  //const Facility_List = JSON.parse(localStorage.getItem("FacilityList"));

  let All_Facility_label = {
    id: "0",
    name: t(DispensingLanguage[lan][menukey]["All"]),
  };
  const FacilityList = [All_Facility_label].concat(getLabFacilityList());
  //const FacilityList = [All_Facility_label].concat(Facility_List);
  //let newList = {id:"0", name:"All"};
  //const FacilityList = [newList].concat(FacilityListLocal)

  const classes = useStyles();
  const tableRef = useRef();
  const { useState } = React;
  const [dataItems, setDataItems] = useState([]);
  const [isLoadingUi, setLoading] = useState(true);
  const [MenuKeyValue, setMenuKeyValue] = useState(0);
  const [reloadData, setReloadData] = useState(true);

  const queryClient = useQueryClient();

  let currDate = new Date();
  let defaultYear = currDate.getFullYear();
  let defaultMonthId = currDate.getMonth();

  //0=jan
  if (defaultMonthId == 0) {
    defaultYear = defaultYear - 1;
    defaultMonthId = 12;
  } else {
    defaultMonthId = defaultMonthId;
  }

  const [currYearId, setCurrYearId] = useState(defaultYear);
  //const [currMonthId, setCurrMonthId] = useState(defaultMonthId);
  const [currMonthId, setCurrMonthId] = useState(0);
  const [currFacilityId, setCurrFacilityId] = useState(FacilityId);
  // const [bStatusId, setbStatusId] = useState(0);

  const [timestamp, setTimestamp] = useState(Date.now());

  let params = {
    menukey: menukey,
    action: "getDataList",
    currYearId: currYearId,
    currMonthId: currMonthId,
    currFacilityId:
      currFacilityId == 0 && IsAdmin.length != 1 ? -1 : currFacilityId,
    page_limit: JSON.stringify(100),
    page_number: JSON.stringify(0 + 1),
    search_key: "",
    timeStamp: timestamp,
  };

  const { isLoading, error, isError, data, refetch } = useQuery(
    [params],
    api.getLabQuarterCloseData,
    {
      onSuccess: (data) => {
        //alert(6);
        setDataItems(data);
        setLoading(false);
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0, //1000 * 60 * 60 * 24,
    }
  );

  const handleYearChange = (event) => {
    setCurrYearId(event.target.value);
    setLoading(true);
  };

  const [all, setAll] = React.useState("0");

  const handleMonthChange = (event) => {
    setAll(event.target.value);
    setCurrMonthId(event.target.value);
    setLoading(true);
  };

  /*   const handleFacilityChange = (event) => {
    setCurrFacilityId(event.target.value);
    setLoading(true);
  }; */

  /*   const handleFacilityChange = (event, newValue) => {
    let rowId = 0;
    if(newValue == null){
      rowId = 0;
    }else{
      rowId = newValue.id;
    }

    params = {
      menukey: menukey,
      action: "getDataList",
      currYearId: currYearId,
      currMonthId: currMonthId,
      currFacilityId: ((rowId==0) && (UserName !="admin"))?-1:rowId,
      page_limit: JSON.stringify(100),
      page_number: JSON.stringify(0 + 1),
      search_key: "",
      
    };

    setCurrFacilityId(rowId);
    setLoading(true);
    refetch();
  }; */

  const handleFacilityChange = (event, newValue) => {
    let rowId = "";
    if (newValue == null) {
      rowId = "";
    } else {
      rowId = newValue.id;
    }

    setCurrFacilityId(rowId);
  };

  const { isLoading3, mutate: labQuarterCloseByFacility } = useMutation(
    api.labQuarterCloseByFacility,
    {
      onSuccess: (data) => {
        // alert(5.7);

        // swal(t(DispensingLanguage[lan][menukey]['Quarter closed this facility!']), {
        //   icon: "success",
        // });

        setReloadData(!reloadData);
        //swal("Success!", "", "success");
        // refetch();
        //queryClient.getQueriesData("getDataList");
      },
    }
  );

  const { isLoading4, mutate: labQuarterCloseDeleteByFacility } = useMutation(
    api.labQuarterCloseDeleteByFacility,
    {
      onSuccess: (data) => {
        console.log("data output", data);

        // props.openNoticeModal({
        //   isOpen: true,
        //   msg: "data.message",
        //   msgtype: 0,
        // });

        //swal("Success!", "", "success");

        // refetch();

        // alert(5.5);
        // swal(t(DispensingLanguage[lan][menukey]['Data deleted this facility!']), {
        //   icon: "success",
        // });

        setReloadData(!reloadData);
        //queryClient.getQueriesData("getDataList");
      },
    }
  );

  const handleSave = async (e) => {
    let MonthId = e.MonthId;
    let FacilityId = e.FacilityId;
    let StatusId = e.StatusId;

    swal({
      title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
      text: t(
        DispensingLanguage[lan][menukey][
          "You want to quarter close this facility!"
        ]
      ),
      icon: "warning",
      buttons: [
        t(DispensingLanguage[lan][menukey]["No"]),
        t(DispensingLanguage[lan][menukey]["Yes"]),
      ],
      dangerMode: true,
    }).then((willUpdate) => {
      if (willUpdate) {
        // alert(5);
        setLoading(true);
        labQuarterCloseByFacility({
          currYearId,
          MonthId,
          FacilityId,
          StatusId,
          UserId,
        });
        // setbStatusId(1);
        // swal(t(DispensingLanguage[lan][menukey]['Quarter closed this facility!']), {
        //   icon: "success",
        // });
      }
    });
  };

  const handleDeleteByFacility = async (e) => {
    let MonthId = e.MonthId;
    let FacilityId = e.FacilityId;
    let StatusId = e.StatusId;

    swal({
      title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
      text: t(
        DispensingLanguage[lan][menukey][
          "You want to delete this facility data!"
        ]
      ),
      icon: "warning",
      buttons: [
        t(DispensingLanguage[lan][menukey]["No"]),
        t(DispensingLanguage[lan][menukey]["Yes"]),
      ],
      dangerMode: true,
    }).then((willUpdate) => {
      if (willUpdate) {
        // alert(4);
        setLoading(true);
        labQuarterCloseDeleteByFacility({
          currYearId,
          MonthId,
          FacilityId,
          StatusId,
        });
        // setbStatusId(1);
        // swal(t(DispensingLanguage[lan][menukey]['Data deleted this facility!']), {
        //   icon: "success",
        // });
      }
    });
  };

  //  useEffect(() => {
  //   if (currYearId > 0 && currMonthId > 0) {
  //      //getCurrentMonthPatients.refetch();
  //    }
  //  }, [currYearId, currMonthId, currFacilityId]);

  useEffect(() => {
    // console.log("Calling protocol items useeffect");

    // console.log('reloadData: ', reloadData);
    // refetch();

    setTimeout(function () {
      refetch();
    }, 9000);
  }, [reloadData]);

  const columns = [
    { title: "StatusId", field: "StatusId", visible: false },
    { title: "MonthId", field: "MonthId", visible: false },
    { title: "FacilityId", field: "FacilityId", visible: false },
    {
      title: t(DispensingLanguage[lan][menukey]["Sl#"]),
      hozAlign: "center",
      width: 120,
      formatter: "rownum",
      headerHozAlign: "center",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Facility"]),
      headerFilter: true,
      field: "FacilityName",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Quarter"]),
      width: 250,
      headerFilter: true,
      field: "MonthName",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Quarter Close Date"]),
      headerFilter: true,
      width: 250,
      field: "MonthCloseActionDate",
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Actions"]),
      field: "custom",
      hozAlign: "center",
      width: 120,
      headerHozAlign: "center",
      headerSort: false,
      formatter: reactFormatter(<ActionButton />),
    },
  ];

  /* const editAdjustmentType = (rowData) => {}; */

  /* function ActionButton(props: any) {
    const rowData = props.cell._cell.row.data;
    
 
    if(rowData.StatusId !=1){
      return (
        <>
         <Tooltip title={DispensingLanguage[lan][menukey]['Generate']}>
          <AddCircle
            onClick={() => {
              
              handleSave(rowData);
            }}
          />
           </Tooltip> 
         
        </>
      );
    }
    else{
      return (
        <>
         <Tooltip title={DispensingLanguage[lan][menukey]['Delete']}> 
          <DeleteOutline
            onClick={() => {
              handleDeleteByFacility(rowData);
            }}
          />
           </Tooltip> 
        </>
      );
    }
    
 
  } */

  function ActionButton(props: any) {
    const rowData = props.cell._cell.row.data;

    let statusButton = (
      <>
        <AddCircle
          onClick={() => {
            handleSave(rowData);
          }}
        />
      </>
    );

    if (rowData.IsAllowAction == 0) {
      statusButton = <></>;
    } else {
      if (rowData.StatusId == 1) {
        statusButton = (
          <>
            <DeleteOutline
              onClick={() => {
                handleDeleteByFacility(rowData);
              }}
            />
          </>
        );
      }
    }

    if (permissionType) {
      statusButton = <></>;
    }

    return statusButton;
  }

  /*  function ActionButton(props: any) {
    const rowData = props.cell._cell.row.data;
   
 
    let statusButton =(
      <>
       
        <AddCircle
          onClick={() => {
            handleSave(rowData);
          }}
        />
        
        
      </>
     );

    if(rowData.StatusId == 1){
      statusButton= (
        <>
       
          <DeleteOutline
            onClick={() => {
              handleDeleteByFacility(rowData);
            }}
          />
          
        
        </>
      );
    }
 
    return(statusButton);
 
  } */

  return (
    <>
      <div className={classes.uiLanguagePageTitle}>
        <div className="d-flex justify-uiLanguage mb-2">
          <Grid container>
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading">
              <div className="sw_heading_title">
                {DispensingLanguage[lan][menukey]["Quarter Close"]}
              </div>
            </div>
          </Grid>
          </Grid>
        </div>

        {/* start of filter */}
        <Card className="sw_card sw_filter_card">
          <CardContent className="sw_filterCardContent">
            <Grid container spacing={1}>
              <Grid item xs={12} sm={2}>
                <FormControl variant="standard" className={classes.fullWidth}>
                  <InputLabel id="demo-simple-select-helper-label">
                    {DispensingLanguage[lan][menukey]["Year"]}
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-helper-label"
                    id="YearList"
                    name="YearList"
                    value={currYearId}
                    onChange={handleYearChange}
                    fullWidth
                  label={DispensingLanguage[lan][menukey]["Year"]}>
                    {YearList.map((item, index) => {
                      return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormControl variant="standard" className={classes.fullWidth}>
                  <InputLabel id="demo-simple-select-helper-label2">
                    {DispensingLanguage[lan][menukey]["Quarter"]}
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-helper-label2"
                    id="MonthList"
                    name="MonthList"
                    //value={currMonthId}
                    value={all}
                    onChange={handleMonthChange}
                    fullWidth
                  label={DispensingLanguage[lan][menukey]["Quarter"]}>
                    <MenuItem value="0">
                      {" "}
                      {DispensingLanguage[lan][menukey]["All"]}
                    </MenuItem>
                    {QuarterList.map((item, index) => {
                      return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={3}>
                <FormControl className={classes.fullWidth}>
                  <Autocomplete
                    autoHighlight
                    id="FacilityList"
                    disableClearable
                    options={FacilityList}
                    value={
                      FacilityList.find((item) => item.id) == 0 &&
                       IsAdmin.length != 1
                        ? -1
                        : FacilityList.find((item) => item.id == currFacilityId)
                    }
                    disabled={IsAdmin.length > 0 ? false : true}
                    onChange={(event, newValue) =>
                      handleFacilityChange(event, newValue)
                    }
                    getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}

                    renderOption={(props, option) => (
                      <li {...props} key={option.id ?? option.name}>
                        <Typography className="sw_fontSize">{option.name}</Typography>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={DispensingLanguage[lan][menukey]["Facility"]}
                        variant="standard"
                      />
                    )}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={5}></Grid>
            </Grid>
          </CardContent>
        </Card>
        {/* end of filter */}

        <div className="sw_relative">
          {isLoadingUi && <LoadingSpinnerOpaque />}
          <div className="uniqueName">
            <ReactTabulator
              columns={columns}
              data={dataItems}
              height={500}
              layout={"fitColumns"}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default LabQuarterClose;

const useStyles = makeStyles({
  uiLanguagePageTitle: {
    marginTop: "60px",
    color: "white",
    background: "whitesmoke",
    color: "black",
    borderRadius: "10px",
    padding: "1rem",
  },
  tableContainer: { backgroundColor: "whitesmoke", borderRadius: "10px" },
  fullWidth: {
    width: "95%",
  },
  filterDiv: {
    width: "80%",
    display: "flex",
  },
});
